<!--确认退款选择页面-->
<template>
  <el-dialog title="退款方式选择"
             :visible.sync="dialogFormVisible"
             custom-class="mini-dialog"
             center
             :close-on-click-modal="false"
             :modal="true">
    <div>原订单收款方式：<span style="color: red"><b>{{paymethodOld}}</b><b
      v-if="paymethodOld!=''&&paymethodOld!='使用优惠券'&&Math.abs(cstagreementDOtuihuo.discount)>0">+</b><b
      v-if="Math.abs(cstagreementDOtuihuo.discount)>0&&paymethodOld!='使用优惠券'">优惠券</b></span></div>
    <div v-if="Object.keys(cstagreementDOtuihuo).length>0">本次应退金额：<span style="color: red"><b
      v-if="Math.abs(cstagreementDOtuihuo.yfk)>0">{{Math.abs(cstagreementDOtuihuo.yfk)}}元</b><b
      v-if="Math.abs(cstagreementDOtuihuo.yfk)>0&&Math.abs(cstagreementDOtuihuo.discount)>0">+</b><b
      v-if="Math.abs(cstagreementDOtuihuo.discount)>0">返回优惠券{{Math.abs(cstagreementDOtuihuo.discount)}}元</b></span>
    </div>
    <el-radio-group v-model="refund" style="padding-left: 30px;padding-top: 20px;padding-bottom: 10px">
      <el-radio :label="1" v-if="allowrefund&&isshowpaymethod&&!isshowayjs" border>{{'退到：'+paymethod}}</el-radio>
      <el-radio :label="2" v-if="isshowayjs" border>无需退钱</el-radio>
      <el-radio :label="3" v-if="!isshowayjs" border>线下已转</el-radio>
      <el-radio :label="4" v-if="allowrefund&&isshowpaymethod&&!isshowayjs&&paymethod!='余额'" border>{{'退到：余额'}}</el-radio>
    </el-radio-group>
    <textarea style="width: 100%;height: 60px" v-model="remark" placeholder="退款说明"></textarea>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" class="qrbtn" @click="saveData">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {refundList, returngoodssave} from '@/api/set/csagreement';
  import {saveData} from '@/api/set/handlelog';
  import {checkModuleRight} from '@/api/login'

  export default {
    name: "ConfirmRefundEdit",
    data() {
      return {
        allowrefund: false,
        dialogFormVisible: false,
        showtitle: '',
        erpserial: "",
        unitguid: "",
        parentguid: '',
        refund: '',
        paymethod: '',
        paymethodOld: '',
        remark:'',
        isshowpaymethod: false,
        isshowayjs: false,
        formLabelWidth: '120px',
        cstagreementDOtuihuo: {},//退货单
      }
    },
    methods: {
      //处理日志
      handlelog() {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1

        handlelog.casestepname = '退款完成'
        handlelog.remark = '退款完成'
        saveData(handlelog).then(response => {
        })
      },

      initData(item) {
        this.initForm()
        this.erpserial = item.erpserial
        this.unitguid = item.unitguid
        this.parentguid = item.parentguid
        this.dialogFormVisible = true;
        this.isshowayjs = false
        refundList({parentguid: this.parentguid,erpserial:this.erpserial,customerserial:item.customerserial}).then(response => {
          if (response.data.obj) {
            if (response.data.obj == "youhui") {
              this.isshowayjs = true
              this.refund = 2
              this.paymethodOld = "使用优惠券";
              this.cstagreementDOtuihuo = response.data.cstagreementDOtuihuo;
            } else if (response.data.obj == "ayjs") {
              this.isshowayjs = true
              this.refund = 2
              this.paymethodOld = "月结客户";
            } else if (response.data.obj == "yue") {
              this.paymethod = '余额'
              this.isshowpaymethod = true
              this.paymethodOld = response.data.paymethod;
              this.cstagreementDOtuihuo = response.data.cstagreementDOtuihuo;
              this.refund = 1
            } else {
              this.paymethodOld = response.data.obj[0].paymethod;
              this.cstagreementDOtuihuo = response.data.cstagreementDOtuihuo;
              if (response.data.obj[0].paymethod != '转账') {
                this.paymethod = response.data.obj[0].paymethod
                this.refund = 1
                this.isshowpaymethod = true
              } else {
                this.isshowpaymethod = false
                this.refund = 3
              }
            }
          }
          //console.log(JSON.stringify(this.cstagreementDOtuihuo))
        })
      },
      saveData() {
        let paymenthod = ''
        if (this.refund == 1) {
          paymenthod = this.paymethod
        } else if (this.refund == 2) {
          paymenthod = '按月结算'
        } else if (this.refund == 3) {
          paymenthod = '转账'
        } else {
          paymenthod = '余额'
        }

        returngoodssave({unitguid: this.unitguid, refund: paymenthod,remark:this.remark}).then(response => {
          if (response.data.code == 0) {
            var msg = response.data.errormsg;
            if (!msg || msg == '') {
              this.$message({
                message: '退款成功！',
                type: 'success'
              })
            } else {
              this.$message({
                message: msg,
                type: 'warning'
              })
            }
            this.handlelog();
            this.$emit('bindGrid');
            this.dialogFormVisible = false;
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },

      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.erpserial = ""
        this.cstagreementDOtuihuo = {}
      }
    },
    mounted() {
      checkModuleRight({name: 'allowrefund'}).then(reponse => {//是否启用在线退款功能
        this.allowrefund = reponse.data.code == 0;
      });
    },
    components: {}
  }
</script>


<style scoped>
  .Hid {
    display: none;
  }

  .ddinfo {
    border-collapse: collapse;
    width: 100%;
    margin-top: 12px;

  }

  .ddinfo td {
    font-size: 14px;
    text-align: center;
    border: 1px solid #E0DFDF;
  }
</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/ConfirmRefundEdit.vue